module.exports = __webpack_public_path__ + "vue/img/platforms-kz.23cfc0fe.svg";